// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"82442ff3","436":"5503dcc8","453":"f394a27d","501":"54a36fab","606":"46970318","925":"7398cd3a"}[chunkId] + ".chunk.js";
};